import { createAsyncThunk } from '@reduxjs/toolkit';
import { TAsyncThunkState } from '../../../types';
import {
  TApiaFunction,
  TApiaFunctionPageInfo,
  TApiaLoad,
} from '../../../../../types';
import store from '../../../..';
import { responsiveTableActions } from '../../../../responsiveTableSlice';
import { getCurrentListId } from '../../../../../components/apia/common/lists/hooks/useCurrentListId';
import ApiaApi, { makeApiaUrl } from '../../../../../api/apiaApi/apiaApi';
import { arrayOrArray } from '../../../../../utils/util';
import { parseRows } from '../../util/rowsParser';
import { TResponsiveTableRow } from '../../../../../components/common/generic/responsiveTable/types';
import { buttonsActions } from '../../../../buttonsSlice';

type TSort = {
  listId: string;
  orderBy?: string | number;
  columnIndex?: number;
  forceAjaxUrl?: boolean;
  forceTabId?: boolean;
};

const sort = createAsyncThunk<
  null | {
    pageInfo?: TApiaFunctionPageInfo;
    table?: TResponsiveTableRow[];
    columnIndex: number;
  },
  TSort,
  TAsyncThunkState
>(
  'listSlice/sort',
  async (
    { listId, orderBy, columnIndex, forceAjaxUrl = false, forceTabId = false },
    thunkApi,
  ) => {
    store.dispatch(
      responsiveTableActions.update({
        tableName: getCurrentListId(),
        selectedRows: [],
      }),
    );

    const state = thunkApi.getState().listSlice.lists[listId];

    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );

    const response = await ApiaApi.post<TApiaLoad<TApiaFunction>>(
      makeApiaUrl({
        action: 'sort',
        react: true,
        orderBy: orderBy ?? columnIndex,
        ajaxUrl: forceAjaxUrl ? state.ajaxUrl : undefined,
        tabId: forceTabId ? state.tabId : undefined,
      }),
    );

    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: false,
          action: 'disableTable',
        },
      ]),
    );
    if (response && response.data) {
      const pageInfo = response?.data?.function?.messages?.result?.pageInfo;
      const row = response?.data?.function?.messages?.result?.table?.row;

      return {
        columnIndex: Number(columnIndex ?? 0),
        pageInfo,
        table: parseRows(listId, (row && arrayOrArray(row)) || []),
      };
    }
    return {
      columnIndex: Number(columnIndex ?? 0),
    };
  },
);

export default sort;
